export default "__VITE_ASSET__B8zW_pRj__"